import React from 'react';
import { Typography, Link } from '@mui/material';

const SimContactSupport = ({ email = 'it@simsouls.com' }) => {
	return (
		<Typography textAlign={'justify'}>
			If you have any questions or concerns about this Policy or our privacy practices or your dealings with this
			Website, you can contact us at{' '}
			<Link href='#' underline='none'>
				{email}
			</Link>
			.
		</Typography>
	);
};

export default SimContactSupport;
